import { useEffect, useMemo } from 'react'
import { Linking } from 'react-native'
import { useLayout } from '../../../hooks/index.js'
import { ArticleBlockContent } from '../../blog/components/ArticleBlock/ArticleBlockContent.js'
import { BlockBackgrounded } from '../../blog/components/ArticleBlock/BlockBackgrounded.js'
import { AdInView } from '../AdPlacement.js'
import { useSkipListAd } from '../listAdInsertion/ListAdInsertionContext'
import { useBannerAdDecision } from '../useBannerAdDecision.js'

export const CloseUpListAd = ({ zone, placement, index }) => {
  const { onLayout, width } = useLayout()

  const { bannerData, loading } = useBannerAdDecision(zone, placement)

  const skipAd = useSkipListAd()

  useEffect(() => {
    if (!loading && bannerData?.message === 'no ads' && zone && placement) {
      skipAd(zone, placement, index)
    }
  }, [loading, bannerData?.message, zone, placement, index, skipAd])

  const adArticle = useMemo(
    () => ({
      title: bannerData?.custom?.heading ?? bannerData?.title,
      listDescription: bannerData?.custom?.longDescription ?? bannerData?.description,
      externalImage: bannerData?.images?.[0]?.url,
      cta: {
        title: bannerData?.ctaText,
        url: bannerData?.clickUrl,
      },
      categories: [
        {
          slug: 'sponsored',
          label: 'Sponsored',
        },
      ],
    }),
    [bannerData],
  )

  if (loading) {
    return (
      <BlockBackgrounded color="accent" onLayout={onLayout}>
        <ArticleBlockContent width={0} article={adArticle} />
      </BlockBackgrounded>
    )
  }

  return (
    <AdInView data={bannerData}>
      <BlockBackgrounded
        color="accent"
        onLayout={onLayout}
        onPress={() => Linking.openURL(bannerData?.clickUrl)}
      >
        <ArticleBlockContent width={width} article={adArticle} />
      </BlockBackgrounded>
    </AdInView>
  )
}
